import { View, Pressable } from "react-native"
import { Link } from "expo-router"
import Icon from "@react-native-vector-icons/material-design-icons"
import { Card, CardContent, CardHeader, CardTitle } from "@src/components/ui/card"
import { Text } from "@src/components/core"
import { ar } from "@src/i18n/ar"

interface SupplierBrandsCardProps {
  brands: { id: number; name: string }[]
  className?: string
}

export function SupplierBrandsCard({ brands, className }: SupplierBrandsCardProps) {
  if (!brands || brands.length === 0) return null

  return (
    <Card className={className}>
      <CardHeader className="p-4 pb-2 flex-row items-center gap-2">
        <View className="bg-purple-100 rounded-full p-2">
          <Icon name="tag-multiple" size={24} color="#9333EA" />
        </View>
        <CardTitle className="text-lg font-bold text-gray-800">{ar.brands}</CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-2 flex-row flex-wrap gap-2">
        {brands.map((brand) => (
          <Link href={`/dashboard/brand/${brand.id}`} asChild key={brand.id}>
            <Pressable className="bg-purple-50 px-4 py-2 rounded border border-purple-200 active:opacity-70">
              <Text className="text-purple-800 text-sm font-medium">{brand.name}</Text>
            </Pressable>
          </Link>
        ))}
      </CardContent>
    </Card>
  )
}
